import {Component, Injectable, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';
import {Sessioncommand} from './sessioncommand';
const apiUrl = `${environment.apiUrl}/ck/upload`;
@Injectable({
  providedIn: 'root'
})
export class CkEditorUploadAdapter {
  xhr: any;
  loader: any;

  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  // Starts the upload process.
  upload() {
    return this.loader.file
      .then(file => new Promise((resolve, reject) => {
        this._initRequest();
        this._initListeners(resolve, reject, file);
        this._sendRequest(file);
      }));
  }

  // Aborts the upload process.
  abort() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    const xhr = this.xhr = new XMLHttpRequest();
    xhr.open('POST', `${apiUrl}`, true);

    xhr.setRequestHeader('Authorization', 'Bearer  ' + sessionStorage.getItem('token'));
    xhr.responseType = 'json';
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = `Couldn't upload file: ${file.name}.`;
    xhr.addEventListener('error', () => reject(genericErrorText));
    xhr.addEventListener('abort', () => reject());
    xhr.addEventListener('load', () => {
      const response = xhr.response;
      if (!response || response.error) {
        return reject(response && response.error ? response.error.message : genericErrorText);
      }
      const url = response.folder + response.fileKey;
      resolve({
        default: url
      });
    });
    if (xhr.upload) {
      xhr.upload.addEventListener('progress', evt => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }


  _sendRequest(file) {
    const data = new FormData();
    data.append('fileItem', file);
    this.xhr.send(data);
  }
}
